import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Flex,
  Typography,
  Spin,
  message,
} from "antd";
import {
  EditOutlined,
  FileTextOutlined,
  CreditCardOutlined,
  PieChartOutlined,
  ApartmentOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import commonFn from "@/utils/commonFn";

export default function UpdateMenuModal({ open, onCancel, record, onSuccess }) {
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [loading, setLoading] = useState(false); 
  const [detailLoading, setDetailLoading] = useState(false); 

  const iconOptions = [
    { value: "CreditCardOutlined", label: "CreditCardOutlined", icon: <CreditCardOutlined /> },
    { value: "FileTextOutlined", label: "FileTextOutlined", icon: <FileTextOutlined /> },
    { value: "PieChartOutlined", label: "PieChartOutlined", icon: <PieChartOutlined /> },
    { value: "ApartmentOutlined", label: "ApartmentOutlined", icon: <ApartmentOutlined /> },
    { value: "TeamOutlined", label: "TeamOutlined", icon: <TeamOutlined /> },
  ];


  useEffect(() => {
    if (open && record?.menuId) {
      loadMenuDetail(record.menuId);
    }
  }, [open, record]);

  const loadMenuDetail = async (menuId) => {
    setDetailLoading(true);

    const data = await fetchMenuDetail(menuId);

    setDetailLoading(false);

    if (!data) return;

    form.setFieldsValue({
      menuName: data.menuName,
      menuUrl: data.menuUrl,
      type: data.type?.toString(),
      display: data.display?.toString(),
      sort: data.sort,
      remark: data.remark,
      menuIcon: data.menuIcon,
      permissionPath: data.permissionPath,
      // parentMenuId: data.parentMenuId,
    });
  };

  const fetchMenuDetail = async (menuId) => {
    try {
      const res = await http.get(api.getMenuById, {
        params: { menuId },
      });

      if (res?.code === "1") {
        return res.data;
      } else {
        commonFn.modalFailedFn(res);
        return null;
      }
    } catch (err) {
      console.error("getMenuById error:", err);
      return null;
    }
  };


  const onFinish = async (values) => {
    setLoading(true);

    const response = await http.post(api.getUpdateMenu, {
      ...values,
      menuId: record.menuId,
        parentMenuId: record.parentMenuId,
    });

    setLoading(false);

    if (response?.code === "1") {
      message.success("Add menu successfully.");
      onSuccess();
      form.resetFields();
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  return (
    <Modal
      width="50%"
      open={open}
      maskClosable={false}
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            EDIT MENU
          </Typography.Title>
        </Flex>
      }
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
      onCancel={onCancel}
    >
   
      <Spin spinning={detailLoading} tip="Loading...">
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                form={form}
                onFinish={onFinish}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
              >
                <Form.Item
                  name="menuName"
                  label="Name"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="Please enter a Name." />
                </Form.Item>

                <Form.Item
                  name="menuUrl"
                  label="Menu Url"
                  rules={[{ required: true }]}
                >
                  <Input allowClear placeholder="Please enter Menu Url." />
                </Form.Item>

                <Form.Item name="type" label="Type">
                  <Select disabled>
                    <Select.Option value="1">Directory</Select.Option>
                    <Select.Option value="2">Menu</Select.Option>
                    <Select.Option value="3">Button</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  name="display"
                  label="Display"
                  rules={[{ required: true }]}
                >
                  <Select>
                    <Select.Option value="1">Yes</Select.Option>
                    <Select.Option value="2">No</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item name="sort" label="Sort">
                  <Input type="number" allowClear placeholder="Sort number" />
                </Form.Item>

                <Form.Item name="remark" label="Remark">
                  <Input allowClear placeholder="Remark" />
                </Form.Item>

                <Form.Item name="menuIcon" label="Menu Icon">
                  <Select optionLabelProp="label">
                    {iconOptions.map((i) => (
                      <Select.Option key={i.value} value={i.value} label={i.label}>
                        {commonFn.iconDocFn(i.value)} {i.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item name="permissionPath" label="Permission Path">
                  <TextArea />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Spin>
    </Modal>
  );
}
